<template>
  <div
    class="w-64 xl:w-56 lg:w-48 md:w-full fixed left-0 top-0 bottom-0 text-sm text-neutral-100 bg-primary-700 border-t-4 border-primary-200 shadow-xl z-100 flex justify-center transition"
    :class="{
      'md:opacity-0 md:pointer-events-none': !isOpen,
      sidebar: check_mobile ? true : false,
      'sidebar-closed': isMenuClosed,
    }"
    @mouseenter="openMenu"
    @mouseleave="closeMenu"
  >
    <div
      class="flex flex-col md:max-w-md w-full py-4 overflow-y-auto hide-scrollbar"
    >
      <div @click.prevent="menuFixFun" class="flex flex-row-reverse mr-4">
        <div style="background-color: #000000" class="items-end">
          <Icon-Play v-if="menuFix" style="" />
          <div v-else>
            <Icon-ArrowRight v-if="isMenuClosed" style="" />
            <Icon-ArrowLeft v-else style="" />
          </div>
        </div>
      </div>

      <div class="sidebar-header flex justify-center relative">
        <div class="w-23 self-center text-neutral-100">
          <router-link :to="{ name: 'dashboard' }">
            <Logo :style="!isMenuClosed ? 'width:140px' : 'width:80px'" />
          </router-link>
        </div>
        <a href="#" @click.prevent="closeSidebar">
          <Icon-Cross
            :class="check_mobile ? 'mt-4' : ''"
            class="hidden md:block absolute-center-y text-primary-600 right-0 mr-4"
          />
        </a>
      </div>
      <div v-show="!isMenuClosed" class="flex flex-col w-full mt-8">
        <User-Avatar :avatar="getUser.foto_perfil" class="self-center" />
        <div class="mt-6">
          <Float-List floatClasses="w-full">
            <template #trigger>
              <div class="flex flex-col">
                <div class="flex justify-between items-center">
                  <h3
                    class="font-display font-bold leading-normal px-4 text-base text-neutral-100"
                  >
                    Olá, {{ getUserFirstName }}
                  </h3>
                  <a href="#" class="mx-4" @click.prevent>
                    <Icon-Dropdown class="w-4 h-4" />
                  </a>
                </div>
              </div>
            </template>
            <template #target>
              <ul
                class="mt-2 flex flex-col text-neutral-100 bg-neutral-700 py-4 border-b-2 border-neutral-800 shadow-xl md:mx-4"
              >
                <router-link
                  :to="{ name: 'profile' }"
                  class="menu-item relative cursor-pointer hp600"
                  tag="li"
                  exact
                >
                  <div
                    class="absolute right-0 top-0 bottom-0 flex items-center menu-mark transition text-primary-500"
                  >
                    <SVG-Menu-Mark class="w-1" />
                  </div>
                  <div class="w-full flex px-4 items-center">
                    <Icon-User />
                    <span class="ml-6">Editar Perfil</span>
                  </div>
                </router-link>
                <li class="menu-item mt-4 relative hp600">
                  <div
                    class="absolute right-0 top-0 bottom-0 flex items-center menu-mark transition text-error-500"
                  >
                    <SVG-Menu-Mark class="w-1" />
                  </div>
                  <a
                    @click.prevent="onLogout"
                    href="#"
                    class="w-full flex px-4 items-center"
                    style="color: red; font-weight: 500"
                  >
                    <Icon-Logout />
                    <span class="ml-6">Sair</span>
                  </a>
                </li>
              </ul>
            </template>
          </Float-List>
        </div>
      </div>
      <div v-show="!isMenuClosed" class="flex w-full mt-8">
        <form class="mx-auto" @submit.prevent="searchEmpresa">
          <div class="relative text-primary-400 focus-within:text-primary-400">
            <span class="absolute inset-y-0 left-0 flex items-center pl-2">
              <button
                type="submit"
                class="p-1 focus:outline-none focus:shadow-outline"
              >
                <svg
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  class="w-6 h-6"
                >
                  <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                </svg>
              </button>
            </span>
            <input
              type="search"
              name="q"
              v-model="search"
              class="py-2 text-sm text-white bg-primary-800 rounded-md pl-10 focus:outline-none focus:bg-primary-900 focus:text-primary-200"
              placeholder="Pesquisar empresa"
              autocomplete="off"
            />
          </div>
        </form>
      </div>
      <ul class="flex flex-col mt-2" style="font-family: 'Comfortaa'">
        <router-link
          v-for="item in menuDefaultItems"
          :key="item.id"
          :to="{ name: item.to }"
          :class="`transition hp600 py-2  menu-item mt-2 relative cursor-pointer text-md order-${
            item.order || '50'
          }`"
          tag="li"
          active-class="active"
          exact
        >
          <div
            class="absolute right-0 top-0 bottom-0 flex items-center menu-mark transition text-neutral-100"
          >
            <SVG-Menu-Mark class="w-1" />
          </div>
          <div class="w-full flex px-4 items-center">
            <component :is="`Icon-${item.icon}`" />
            <span
              v-show="!isMenuClosed"
              class="ml-6 link-label"
              v-text="item.label"
            ></span>
          </div>
        </router-link>
        <li
          v-for="submenu in menus.submenus"
          :key="submenu.id"
          :class="`py-2 transition  hp600  relative order-${
            submenu.order || '50'
          }`"
        >
          <b-collapse :open="false">
            <a
              href="#"
              @click.prevent
              class="hp600 w-full flex px-4 justify-between items-center relative menu-item text-md"
              slot="trigger"
            >
              <div class="flex">
                <component
                  class="text-neutral-300"
                  :is="`Icon-${submenu.icon}`"
                />
                <span
                  v-show="!isMenuClosed"
                  class="ml-6 link-label text-neutral-100"
                  v-text="submenu.label"
                ></span>
              </div>
              <Icon-Dropdown size="3" />
              <div
                class="absolute right-0 top-0 bottom-0 flex items-center menu-mark transition text-primary-900"
              >
                <SVG-Menu-Mark class="w-1 text-neutral-100" />
              </div>
            </a>
            <ul v-show="!isMenuClosed" class="mt-4" style="font-size: 13px">
              <li v-for="item in submenu.items" :key="item.id">
                <router-link
                  :to="{
                    name: item.to,
                    params: item.params ? item.params : {},
                  }"
                  exact-active-class="active"
                  class="menu-item mt-4 relative flex text-neutral-500"
                  active-class=""
                  v-if="!itemHasPermission(item) || !itemHasRole(item)"
                >
                  <div
                    class="absolute right-0 top-0 bottom-0 flex items-center menu-mark transition text-neutral-300"
                  >
                    <SVG-Menu-Mark class="w-1" />
                  </div>
                  <div class="w-full flex pl-8 pr-4 items-center">
                    <component
                      class="text-neutral-300"
                      :is="`Icon-${item.icon}`"
                    />
                    <span
                      class="ml-6 link-label text-neutral-100"
                      v-text="item.label"
                    ></span>
                  </div>
                </router-link>
              </li>
            </ul>
          </b-collapse>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Logo from "@/components/svgs/Logo";
import SVGMenuMark from "@/components/svgs/MenuMark";
import FloatList from "@/components/helpers/FloatList";
import UserAvatar from "@/components/layouts/UserAvatar";
import { mapGetters, mapActions } from "vuex";
import Bus from "@/services/bus";
import bus from "@/services/bus";
import { empresasShowRequest } from "@/services/requests/empresas";
import { computed } from "vue";

export default {
  components: { Logo, SVGMenuMark, FloatList, UserAvatar },
  data() {
    return {
      isMenuClosed: false,
      isOpen: false,
      search: null,
      menus: {
        default: [
          {
            label: "Dashboard",
            to: "dashboard",
            icon: "Dashboard",
            order: 1,
          },
          {
            label: "Relatórios",
            to: "exports",
            icon: "Document",
            // order: 13,
          },
        ],
        submenus: [
          {
            label: "Empresas",
            icon: "Company",
            order: 2,
            items: [
              {
                label: "Cadastrar",
                to: "empresas.create",
                icon: "Plus",
              },
              {
                label: "Pesquisar",
                to: "empresas.index",
                icon: "Search",
              },
              {
                label: "Todas",
                to: "empresas.all",
                icon: "FileDocumentBox",
              },
              {
                label: "Atividades",
                to: "empresas.atividades",
                icon: "Collection",
              },
            ],
          },
          {
            label: "Clientes",
            icon: "User",
            order: 3,
            items: [
              {
                label: "Cadastrar",
                to: "clientes.create",
                icon: "Plus",
              },
              {
                label: "Pesquisar",
                to: "clientes.index",
                icon: "Search",
              },
            ],
          },
          {
            label: "Legalização & Onboarding",
            icon: "Document",
            order: 4,
            items: [
              {
                label: "Pós Cadastro",
                to: "empresas.posCadastro",
                icon: "Collection",
              },
              {
                label: "Alteração e Baixa",
                to: "empresas.alteracao",
                icon: "Edit",
              },
              {
                label: "Renovação Alvará",
                to: "alvara.renovacao",
                icon: "Edit",
              },
              {
                label: "Alvarás",
                to: "empresas.alvara-taxas.index",
                icon: "Document",
              },
              {
                label: "Taxas de Alvarás",
                to: "empresas.taxas.index",
                icon: "Document",
              },
              //     {
              //   label: "Taxas Vencidas",
              //   to: "empresas-taxas-vendas.index",
              //   icon: "Document",
              // },
              {
                label: "Procuração",
                to: "empresas.procuracao.index",
                icon: "Document",
              },
              {
                label: "Certificados",
                to: "empresas.certificado.index",
                icon: "Document",
              },
              {
                label: "Viabilidade",
                to: "viabilidade",
                icon: "Checkbox",
                permissions: ["listar viabilidade"],
              },
              {
                label: "Junta Comercial",
                to: "juntaComercial.index",
                icon: "Taxes",
              },
              {
                label: "Relatórios",
                to: "relatorio.legalizacao",
                icon: "Taxes",
              },
            ],
          },
          {
            label: "Comercial",
            icon: "Document",
            order: 5,
            items: [
              {
                label: "Contratantes",
                to: "contratantes.index",
                icon: "Business",
              },
              {
                label: "Indicações",
                to: "indicacoes.index",
                icon: "Users",
                permissions: ["listar indicacoes"],
              },
              {
                label: "Relatórios",
                to: "relatorio.comercial",
                icon: "Taxes",
              },
            ],
          },
          {
            label: "Qualidade",
            icon: "Document",
            order: 6,
            items: [
              {
                label: "Satisfação",
                to: "satisfacao.index",
                icon: "Users",
                permissions: ["listar viabilidade"],
              },
              {
                label: "Motivo Retenção",
                to: "empresas.motivoRetencao",
                icon: "Document",
              },
              {
                label: "Retenção",
                to: "empresas.retencao",
                icon: "Document",
              },
              {
                label: "Dúvidas Clientes",
                to: "qualidade.texto",
                icon: "Document",
              },
              {
                label: "Informações Documentadas",
                to: "qualidade.pasta",
                icon: "Folder",
                permissions: ["acesso gerenciador qualidade"],
              },
            ],
          },
          {
            label: "CS",
            icon: "Users",
            order: 7,
            items: [
              // {
              //   label: "Simulador Nota Fiscal",
              //   to: "simulador.NotaFiscal",
              //   icon: "FileDocumentBox",
              // },
              {
                label: "CRM",
                to: "gerencimento-crm.index",
                icon: "Document",
              },
              {
                label: "Local de Trabalho",
                to: "tomadores.index",
                icon: "Document",
              },

              {
                label: "Links e Informações",
                to: "links.index",
                icon: "Link",
              },

              // {
              //   label: "Espelho Notafiscal",
              //   to: "espelho-nota-fiscal.index",
              //   icon: "Document",
              // },
              {
                label: "Atividades",
                params: { setor: "cs" },
                to: "ativiades-competencia.index",
                icon: "Document",
              },
            ],
          },
          {
            label: "Contabilidade",
            icon: "User",
            order: 8,
            items: [
              {
                label: "Livro Fiscal",
                to: "clientes.livro-fiscal.index",
                icon: "Document",
                role: ["Gerenciar livro fiscal"],
              },
              {
                label: "Holerites",
                to: "uploads.index",
                icon: "UploadCloud",
                role: ["Gerenciar uploads"],
              },
              {
                label: "Simulador",
                to: "simulator",
                icon: "FileDocumentBox",
                order: "last",
              },
              {
                label: "Faturamentos",
                to: "financeiro.upfature",
                icon: "UploadCloud",
              },
              {
                label: "Fechamento",
                to: "competencia.index",
                icon: "Document",
              },
              {
                label: "Atividades",
                params: { setor: "contabilidade" },
                to: "ativiades-competencia.index",
                icon: "Document",
              },
              {
                label: "Parcelamentos",
                to: "empresas-parcelamento.index",
                icon: "Money",
              },
            ],
          },
          {
            label: "Guias",
            icon: "Document",
            order: 9,
            items: [
              {
                label: "Gerenciamento",
                to: "guias.gerenciamento",
                icon: "Setting",
              },
              {
                label: "Upload",
                to: "guias.upload",
                icon: "UploadCloud",
              },
              {
                label: "Não processadas",
                to: "guias.nao-processadas",
                icon: "Alert",
              },
              {
                label: "Datas padrão",
                to: "guias.data-vencimento-padrao",
                icon: "Alert",
              },
            ],
          },
          {
            label: "IRPF",
            icon: "FileDocumentBox",
            order: 10,
            items: [
              {
                label: "Gerenciar Declarações",
                to: "irpf.index",
                icon: "FileDocumentBox",
              },
              {
                label: "Conf. Questionário",
                to: "irpf.questionario",
                icon: "Setting",
              },

              {
                label: "Controle IRPF",
                to: "controle-irpf-comp.index",
                icon: "FileDocumentBox",
              },
              //   {
              //   label: "Acompanhamento Clientes IRPF",
              //   to: "acompanhamento-irpf.index",
              //   icon: "Rh",
              // },
            ],
          },
          /// TODO: retirar caso não for usar
          // {
          //   label: "CND",
          //   icon: "BankAgency",
          //   order: 11,
          //   items: [
          //     {
          //       label: "Gerenciamento",
          //       to: "certidao-negativa.gerenciamento",
          //       icon: "Setting",
          //     },
          //     {
          //       label: "Upload",
          //       to: "certidao-negativa.upload",
          //       icon: "UploadCloud",
          //     },
          //     {
          //       label: "Não processadas",
          //       to: "certidao-negativa.nao-processadas",
          //       icon: "Alert",
          //     },
          //   ],
          // },
          {
            label: "Prolabores",
            icon: "MoneyBag",
            order: 12,
            items: [
              {
                label: "Gerenciamento",
                to: "receitas.gerenciamento",
                icon: "Setting",
              },
              {
                label: "Upload",
                to: "receitas.upload",
                icon: "UploadCloud",
              },
              {
                label: "Não processadas",
                to: "receitas.nao-processadas",
                icon: "Alert",
              },
              {
                label: "Divisão de Receita",
                to: "receitas.divisao",
                icon: "Rh",
              },
            ],
          },
          {
            label: "Financeiro",
            icon: "Money",
            order: 12,
            items: [
              {
                label: "Faturas",
                to: "financeiro.gerenciar-fatura",
                icon: "Document",
              },
              {
                label: "Cartão Crédito",
                to: "empresas.cartaoCredito",
                icon: "Money",
              },
              {
                label: "Tipo Cobrança",
                to: "financeiro.tipoCobranca",
                icon: "Setting",
              },
              {
                label: "Motivo Cancelamento",
                to: "financeiro.FaturaMotivoCancelamento",
                icon: "Setting",
              },
              {
                label: "Assinaturas",
                to: "financeiro.subscriptions",
                icon: "Setting",
              },
              {
                label: "Planos",
                to: "financeiro.plans",
                icon: "Setting",
              },
              {
                label: "NFSE",
                to: "financeiro.nfse",
                icon: "FileDocumentBox",
              },
              // {
              //   label: "Contas a receber",
              //   to: "financeiro.contas-receber",
              //   icon: "Setting",
              // },
                {
                label: "Agendamentos",
                to: "financeiro.contas-receber",
                icon: "Setting",
              },
              {
                label: "Relatórios",
                to: "financeiro.relatorios",
                icon: "Setting",
              },
            ],
          },
          {
            label: "Recalculo de guias",
            icon: "Document",
            // order: 14,
            items: [
           
              {
                label: "Arquivos Recálculo",
                to: "gerais.recalculo",
                icon: "Document",
              },
              {
                label: "Upload",
                to: "gerais.upload",
                icon: "UploadCloud",
              },
              {
                label: "Não processadas",
                to: "gerais.nao-processadas",
                icon: "Alert",
              },
            ],
          },
          {
            label: "Autenticação",
            icon: "Warning",
            // order: 12,

            items: [
              {
                label: "Carteiras",
                to: "carteiras.index",
                icon: "Folder",
              },
              {
                label: "Usuários",
                to: "users.index",
                icon: "Users",
              },
              {
                label: "Funções",
                to: "roles.index",
                icon: "Locker",
              },
              {
                label: "Permissões",
                to: "permissions.index",
                icon: "Key",
              },
              {
                label: "Logs Usuário",
                to: "users.LogsUsuario.LogsUsuario",
                icon: "Folder",
              },
            ],
          },
        ],
      },
    };
  },
  methods: {
    check_mobile() {
      var check = false; //wrapper no check
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    },
    async openMenu() {
      if (!this.menuFix) {
        this.isMenuClosed = false;
        await this.$store.dispatch("configEmpresa/widthsystem", 64);
        //  console.log(this.$store.state.configEmpresa.widthsystem)
      }
    },
    async closeMenu() {
      if (!this.menuFix) {
        this.isMenuClosed = true;
        await this.$store.dispatch("configEmpresa/widthsystem", 20);
      }
      // console.log(this.$store.state.configEmpresa.widthsystem)
    },
    async menuFixFun() {
      await this.$store.dispatch(
        "configEmpresa/setmenufix",
        this.menuFix ? false : true
      );

      this.isMenuClosed = false;
      await this.$store.dispatch("configEmpresa/widthsystem", 64);
    },
    async menuFixFun2() {
      await this.$store.dispatch("configEmpresa/setmenufix", this.menuFix);

      if (this.menuFix)
        await this.$store.dispatch("configEmpresa/widthsystem", 64);
      else this.closeMenu();

      // this.isMenuClosed = false;

      // await this.$store.dispatch("configEmpresa/widthsystem", 64);
    },
    ...mapActions(["logout"]),
    searchEmpresa() {
      if (!this.search) return;
      bus.globalLoading = true;
      empresasShowRequest(this.search)
        .then((res) => {
          this.$store.dispatch("setEmpresa", res.data.data);
          this.$router.push({ name: "empresas.show" });
        })
        .catch(() => this.$snack.error("Empresa não encontrada"))
        .finally(() => (bus.globalLoading = false));
    },
    onLogout() {
      OneSignal.push(function () {
        OneSignal.removeExternalUserId();
      });
      this.logout();
      document.body.classList.remove("overflow-hidden");
      this.$snack.success("Logout feito com sucesso");
    },
    closeSidebar() {
      this.isOpen = false;
      document.body.classList.remove("overflow-hidden");
    },
    openSidebar() {
      this.isOpen = true;
      document.body.classList.add("overflow-hidden");
    },
    itemHasPermission(item) {
      if (!item.permissions) return false;
      return !!item.permissions.filter((curr) => this.$hasPermission(curr))
        .length;
    },
    itemHasRole(item) {
      if (!item.roles) return false;
      return !!item.roles.filter((curr) => this.$hasRole(curr)).length;
    },
  },
  computed: {
    ...mapGetters(["getUserFirstName", "getUser"]),
    menuDefaultItems() {
      return this.menus.default.filter((curr) => {
        if (!curr.permissions && !curr.roles) return true;
        return this.itemHasRole(curr) || this.itemHasPermission(curr);
      });
    },
    submenus() {
      return this.menus.submenus.filter((curr) => {
        if (!curr.permissions && !curr.roles) return true;
        return this.itemHasRole(curr) || this.itemHasPermission(curr);
      });
    },
    menuFix() {
      return this.$store.state.configEmpresa.menufix;
    },
  },
  watch: {
    $route() {
      this.closeSidebar();
    },
  },
  mounted() {
    Bus.$on("open-sidebar", () => this.openSidebar());
    // this.$store.dispatch("configEmpresa/widthsystem", 64);
    this.menuFixFun2();
  },
};
</script>

<style scoped lang="scss">
.sidebar::-webkit-scrollbar {
  display: none;
}

.menu-item {
  &:hover {
    .link-label {
      font-weight: bold;
    }

    .menu-mark {
      opacity: 100;
    }
  }

  .menu-mark {
    opacity: 0;
    @screen md {
      margin-right: 1rem;
    }
  }

  &.active {
    font-weight: bold;
    @apply text-neutral-100;
    .menu-mark {
      opacity: 100;
    }
  }
}

.bg-primary-700 {
  background-color: #031127;
}

.bg-primary-800 {
  background-color: #012051;
}
.hp600:hover {
  background-color: #061d42;
}
.sidebar {
  transition: width 0.6s ease;
}

.sidebar.sidebar-closed {
  width: 80px;
}

.sidebar-header {
}

.sidebar-menu {
  list-style: none;
  padding: 0;
  margin-top: 20px;
}

.sidebar-menu li {
  padding: 10px;
  cursor: pointer;
}

.toggle-button {
  position: absolute;
  bottom: 20px;
  left: 20px;
  background-color: #231616;
  border: none;
  outline: none;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.toggle-button:hover {
  transform: scale(1.5);
}
</style>
